import React from 'react'; // eslint-disable-line import/no-extraneous-dependencies
import Link from 'gatsby-link';

import styles from './navbar.module.css';
import logo from '../../../static/images/vrtwinslogo.png';

import Links from './links';

const Navbar = () => (
  <header className={styles.header}>
    <Link to="/" className={`${styles.headerLogo}`} >
      <img className={styles.logo} alt="VR Twins Logo" src={logo} />
    </Link>

    <div className={` ${styles.navBar} ${styles.hideSmall}`}>
      <Links />
    </div>
  </header>
);


export default Navbar;



// WEBPACK FOOTER //
// ./src/components/navbar/index.jsx